<div>
  <!-- <h3 class="table-name">{{ _classicService.activeTable.name }}</h3> -->

  <div class="pot-container border-2 border-solid border-[#FFA200]">
    <div class="pot-label">
      <p class="shadow-2xl shadow-black">
        {{ _classicService.activeTable.potBonus | number: '0.0-2' }}
      </p>
    </div>
    <img src="assets/rush/5K-gold-coins-in-pot.png" alt="" />
  </div>
</div>
